import { render, staticRenderFns } from "./leicaCard.vue?vue&type=template&id=34e4c072&scoped=true&"
import script from "./leicaCard.vue?vue&type=script&lang=js&"
export * from "./leicaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4c072",
  null
  
)

export default component.exports